import React from 'react';
import Layout from '../../components/Shared/Layout';
import BED_BATH_BEYOND from '../../components/Portfolio/bed-bath-beyond';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class BedBathBeyond extends React.Component {
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/fortune500-ar',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <BED_BATH_BEYOND />
      </Layout>
    );
  }
}

export default BedBathBeyond;
